import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SimilarProductsState } from "./similarProducts.state";
import { getSimilarProducts } from "./similarProducts.thunk";
import {
  SimilarProductsData,
  SimilarProductsResponse,
} from "./similarProducts.types";

const initialState: SimilarProductsState = {
  data: null,
  status: "idle",
  error: null,
  currentSlug: null,
  ssrHydrated: false,
};

export const similarProductsSlice = createSlice({
  name: "similarProducts",
  initialState,
  reducers: {
    resetSimilarProducts: (state) => {
      state.data = null;
      state.status = "idle";
      state.error = null;
      state.currentSlug = null;
      state.ssrHydrated = false;
    },
    // SSR ilk sayfa sonuçlarını mount'ta yükler (client fetch flicker'ını önler).
    // ssrHydrated=true → fetch effect ilk client fetch'ini atlar (GenericProductsPage pattern).
    loadInitialSimilarProducts: (
      state,
      action: PayloadAction<{ data: SimilarProductsData; slug: string }>,
    ) => {
      if (state.status !== "idle") return;
      state.data = action.payload.data;
      state.status = "success";
      state.currentSlug = action.payload.slug;
      state.ssrHydrated = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSimilarProducts.pending, (state, action) => {
        const isNewSlug = state.currentSlug !== action.meta.arg.slug;
        const isFirstPage = (action.meta.arg.params.page || 1) === 1;

        if (isNewSlug) {
          state.data = null;
          state.currentSlug = action.meta.arg.slug;
        } else if (isFirstPage) {
          state.data = null;
        }

        state.status = "loading";
        state.error = null;
        state.ssrHydrated = false; // ilk client fetch SSR bayrağını temizler
      })
      .addCase(
        getSimilarProducts.fulfilled,
        (state, action: PayloadAction<SimilarProductsResponse>) => {
          state.status = "success";
          const isFirstPage = action.payload.data.pagination.current_page === 1;
          
          if (isFirstPage) {
            state.data = action.payload.data;
          } else {
            // Append to existing items
            if (state.data) {
              state.data = {
                items: [
                  ...state.data.items,
                  ...action.payload.data.items,
                ],
                pagination: action.payload.data.pagination,
              };
            }
          }
        },
      )
      .addCase(
        getSimilarProducts.rejected,
        (state, action: PayloadAction<string | undefined>) => {
          state.status = "error";
          state.error =
            action.payload ?? "Benzer ürünler yüklenirken bir hata oluştu.";
        },
      );
  },
});

export const { resetSimilarProducts, loadInitialSimilarProducts } =
  similarProductsSlice.actions;
export default similarProductsSlice.reducer;